const FinancialView = () => {
  return <div>FinancialView</div>;
};

export default FinancialView;
